/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPCONSULTANTSIGNINGROLE = {
    Assistant: 'ASS',
    BrokerConsultant: 'BC',
    BusinessDevelopmentConsultant: 'BDC',
    SalesSupportAssistant: 'SSA'
} as const;
export type IAPCONSULTANTSIGNINGROLE = typeof IAPCONSULTANTSIGNINGROLE[keyof typeof IAPCONSULTANTSIGNINGROLE];


export function IAPCONSULTANTSIGNINGROLEFromJSON(json: any): IAPCONSULTANTSIGNINGROLE {
    return IAPCONSULTANTSIGNINGROLEFromJSONTyped(json, false);
}

export function IAPCONSULTANTSIGNINGROLEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPCONSULTANTSIGNINGROLE {
    return json as IAPCONSULTANTSIGNINGROLE;
}

export function IAPCONSULTANTSIGNINGROLEToJSON(value?: IAPCONSULTANTSIGNINGROLE | null): any {
    return value as any;
}

